import * as Redux from 'redux';



export function timerMiddleware({ dispatch, getState }) {
    const timers = {};

    const clearTimer = (timerName: string) => {
        const timer = timers[timerName];
        if (timer) {
            clearInterval(timer.interval);
        }
    };

    const startTimerReduce = (action) => {
        const {
            timerName,
            actionContent,
            timerPeriod,
            timerInterval = 1000,
        } = action.payload;

        // if we start timer that already started
        if (timers[timerName]) {
            clearInterval(timers[timerName].interval);
        }
        // clear
        timers[timerName] = {};
        const current = timers[timerName];

        // set action name
        current.actionContent = actionContent;

        // if timer period provided
        if (timerPeriod) {
            current.period = timerPeriod;
            current.interval = setInterval(() => {
                current.period -= 1;
                if (current.period === 0) {
                    clearInterval(current.interval);
                    dispatch(actionContent);
                } else {
                    dispatch(actionContent);
                }
            }, timerInterval);
        } else {
            timers[timerName].interval = setInterval(() => {
                dispatch(actionContent);
            }, timerInterval);
        }
    }

    const stopTimerReduce = (action) => {
        const { timerName } = action;
        clearTimer(timerName);
    }

    return next => action => {
        switch (action.type) {
            case ActionType.StartTimer:
                startTimerReduce(action);
                break;
            case ActionType.StopTimer:
                stopTimerReduce(action);
                break;
            default: {
                return next(action);
            }
        }
    }
}

export enum ActionType {
    StartTimer = "StartTimer",
    StopTimer = "StopTimer",
}

export interface TimerPayload {
    timerName: string;
    actionContent: Redux.Action;
    timerInterval: number;
    timerPeriod?: number;
}

export class StartTimerAction implements Redux.Action {
    type: ActionType.StartTimer;
    payload: TimerPayload;
    
    static create(timerName: string, action: Redux.Action, timerInterval: number, timerPeriod?: number): StartTimerAction {

        return {
            type: ActionType.StartTimer,
            payload: {
                timerName: timerName,
                actionContent: action,
                timerPeriod: timerPeriod,
                timerInterval: timerInterval
            }
        }
    }
}

export class StopTimerAction implements Redux.Action {
    type: ActionType.StopTimer;
    timerName: string;

    static create(timerName: string): StopTimerAction {
        return {
            type: ActionType.StopTimer,
            timerName: timerName
        }
    }
}